<ng-content select="input"></ng-content>
<ng-content select="label"></ng-content>
<ng-content select="[etAtomsInputError]"></ng-content>
<ng-content select="[etAtomsInputIcon]"></ng-content>
